<template>
  <div>
    <cost-centre-menu></cost-centre-menu>

    <v-row no-gutters class="mb-4">
      <v-spacer></v-spacer>
      <v-btn class="success" @click="openDialog(null)">{{ $t("settings.costCentre.budget.add") }}</v-btn>
    </v-row>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("settings.costCentre.budget.add") }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-select
              :label="$t('settings.costCentre.budget.costCentre')"
              :rules="[v => v != null || $t('global.error.required')]"
              v-model="form.cost_centre_id"
              :items="costCentres"
              item-text="name"
              item-value="id"
            />
            <v-text-field
              :label="$t('settings.costCentre.budget.amount')"
              :rules="[v => (v != null && v.length > 0) || $t('global.error.required'), v => !isNaN(v) || $t('global.error.notANumber')]"
              v-model="form.amount"
            />
            <date-picker
              :label="$t('settings.costCentre.budget.fromDate')"
              :rules="[v => (v != null && v.length > 0) || $t('global.error.required')]"
              :model.sync="form.from_date"
            />
            <date-picker
              :label="$t('settings.costCentre.budget.toDate')"
              :rules="[v => (v != null && v.length > 0) || $t('global.error.required')]"
              :model.sync="form.to_date"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table :headers="headers" :items="budget">
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ costCentres.find(v => v.id === props.item.cost_centre_id).name }}
          </td>
          <td class="text-left">
            {{ props.item.amount }}
          </td>
          <td class="text-left">
            {{ props.item.from_date }}
          </td>
          <td class="text-left">
            {{ props.item.to_date }}
          </td>
          <td class="text-center justify-center align-content-center px-0">
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn v-on="on" @click="remove(props.item)" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CostCentreMenu from "../../../components/Settings/CostCentre/CostCentreMenu";
import DatePicker from "../../../components/CustomInputComponents/DatePicker";
export default {
  name: "SettingsCostCentreBudgetView",
  components: { DatePicker, CostCentreMenu },
  data: () => ({
    dialog: false,
    formValid: true,
    search: "",
    budget: [],
    costCentres: [],
    form: {
      id: null,
      cost_centre_id: null,
      amount: null,
      from_date: null,
      to_date: null
    },
    cleanForm: null
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("settings.costCentre.budget.costCentre"),
          value: "cost_centre_id",
          sortable: true
        },
        { text: this.$t("settings.costCentre.budget.amount"), value: "amount" },
        { text: this.$t("settings.costCentre.budget.fromDate"), value: "from_date" },
        { text: this.$t("settings.costCentre.budget.toDate"), value: "to_date" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  methods: {
    openDialog(item) {
      if (item !== null) {
        this.form = JSON.parse(JSON.stringify(item));
      } else {
        this.form = JSON.parse(JSON.stringify(this.cleanForm));
      }
      this.dialog = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("settings/cost-centre/save-budget", this.form)
          .then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved")
            });
            this.$emit("saved");
            this.dialog = false;
            this.load();
          })
          .catch(resp => {
            console.log(resp.response);
          });
      }
    },
    load() {
      this.axios.get("settings/cost-centre/get-budget").then(response => {
        this.budget = response.data.budget;
        this.costCentres = response.data.cost_centres;
      });
    },
    remove(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result.then(() => {
        this.axios.post("settings/cost-centre/delete-budget", { id: item.id }).then(() => {
          this.load();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.deleted")
          });
        });
      });
    }
  },
  created() {
    this.load();
    this.cleanForm = JSON.parse(JSON.stringify(this.form));
  }
};
</script>

<style scoped></style>
